import { Button } from "src/components";
import classNames from "classnames";
import { Tab, Transition } from "@headlessui/react";  //M10-11601
import downArrow from "../../assets/down-arrow.svg";
import InvoiceProductMapping from "./invoice-product-mapping.component";
import InvoiceLayout from "../invoice-master/invoice-layout.component";
import PurpleLeftArrowIcon from "../../assets/purple-left-arrow.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/context/store";
import { downloadInvoice } from "src/services/invoice-api";
import { invoiceActions } from "src/context/invoice-slice";
import { useToast } from "src/hooks/useToast";
import InvoiceHeader from "./invoice-header.component";
//M10-11601
import { Fragment, useState } from "react";
import usePermission from "src/hooks/usePermission";
import { fineGrainedPermissionsKeys } from "src/constants/permission";
import { MessageCircle } from "lucide-react";
import VersioningCrate from "src/components/Versioning/versioningModal.component";
import { useOutsideClick } from "src/hooks/useOutsideClick";
import Book from "../../assets/book.png";
import InvoiceRemarks from "./InvoiceRemarks";
//M10-11601
const tabs = ["Header Comparison", "Product Mapping"];
// const tabs = ["Product Mapping"];

const InvoiceComparison = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { invoiceDetails } = useSelector((state: RootState) => state.invoice);
  const { toast } = useToast();
  //M10-11601
  const [VersioningModal, setVersioningModal] = useState(false);
  const [isRemarksShown, setIsRemarksShown] = useState(false);

  const ref = useOutsideClick(() => {
    setIsRemarksShown(false);
  });

  const outSideClickRef = useOutsideClick(() => {
    setVersioningModal(false);
  });

  const { hasPermission: viewRemarks } = usePermission({
    module: fineGrainedPermissionsKeys.INVOICE.VIEWREMARKS.module,
    action: fineGrainedPermissionsKeys.INVOICE.VIEWREMARKS.action,
  });
  //M10-11601

  return (
    <InvoiceLayout>
      {/* M10-11601 */}
      <Transition
        as={Fragment}
        show={isRemarksShown}
        enter="transition transition ease-in-out duration-200 transform"
        enterFrom="translate-x-full"
        enterTo="translate-x-0"
        leave="transition  ease-in-out duration-200 transform"
        leaveFrom="translate-x-0"
        leaveTo="translate-x-full"
      >
        <div className="fixed right-0 inset-0 top-0 z-[500]">
          <InvoiceRemarks invoiceApprovalData={invoiceDetails} invoice_id={Number(invoiceDetails?.invoice?.invoice_id)} ref={ref} />
        </div>
      </Transition>
    {/* M10-11601 */}
      <div className="flex items-center justify-between w-full px-[3.75rem] mt-6 border-b pb-10 shadow-md">
        <div className="flex flex-col">
          <div
            onClick={() => {
              navigate(`/transactions/invoice/${invoiceDetails?.stockist_invoice_attachment_id}/0`);
            }}
            className="flex items-center cursor-pointer font-semibold px-0 py-2 text-lg text-[#7F56D9]"
          >
            <img src={PurpleLeftArrowIcon} alt="back" className="w-3 h-3 mr-3" />
            Back to Invoices
          </div>
          <h1 className="text-[#49484C] font-bold text-[2rem]">Product Mapping</h1>
          {/* M10-11601 */}
          <div className="absolute right-4 flex flex-row gap-3 items-end mt-20">
            {/* Versioning */}
            <div
              onClick={() => setVersioningModal((prev) => !prev)}
            >
              <img src={Book} alt="Version" className="h-10 w-14 " />
            </div>
            {/* Remarks */}
            {viewRemarks && (
              <div
                onClick={() => setIsRemarksShown(true)}
                className="p-2 bg-white cursor-pointer"
              >
                <MessageCircle className="text-gray-500 h-6 w-6" />
              </div>
            )}
          </div>
          {/* M10-11601 */}
        </div>
      </div>
      <div className="px-[3.75rem]">
        {/* M10-11601 */}
        {VersioningModal && (
          <div ref={outSideClickRef}>
            <VersioningCrate type="Invoice" invoiceId={invoiceDetails?.invoice?.invoice_id} stockistInvAttachmentId={invoiceDetails?.stockist_invoice_attachment_id} />
          </div>
        )}
        {/* M10-11601 */}
        <header className="flex justify-between w-full  mx-auto mt-10">
          <div className="flex items-center">
            <h1 className="font-semibold text-[1.5rem] mr-4">{invoiceDetails?.invoice?.invoice_number}</h1>
            <h1
              className={`font-semibold  flex items-center text-xs h-6 px-2 rounded-full`}
              style={{
                backgroundColor: invoiceDetails?.fileStatusHdr?.color_code?.trim(),
                color: invoiceDetails?.fileStatusHdr?.text_color_code?.trim(),
              }}
            >
              {invoiceDetails?.fileStatusHdr?.fuid_status_desc}
              <img className="w-3 h-3 ml-1" src={downArrow} alt="down-arrow" />
            </h1>
          </div>
          <div className="flex items-center gap-x-2">
            {
              <div className="flex items-center p-2 rounded-md bg-[#f1f1f1]">
                <Button
                  onClick={() => {
                    if (!invoiceDetails?.file_path) {
                      toast({ description: "Invoice not found", variant: "destructive" });
                      return;
                    }
                    downloadInvoice(invoiceDetails?.file_path, invoiceDetails?.company_code).then((res: any) => {
                      if (res?.data?.success && res?.data?.data) {
                        window.open(res?.data?.data, "_blank"); // Opens the link in a new tab
                        //M10-15262
                        dispatch(invoiceActions.setInvoiceVerification({
                          invoiceId: invoiceDetails?.invoice?.invoice_id,
                          isDownloaded: true,
                        }));
                      } else {
                        console.error("Failed to download the invoice.");
                      }
                    });
                  }}
                  className="flex items-center px-4 space-x-2 font-normal bg-[#f1f1f1] border-gray-500 rounded-r-none border-r rounded-l-md h-5 hover:text-gray-600 focus:outline-none focus:ring-0"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1M7 8l5 5m0 0l5-5m-5 5V3" />
                  </svg>
                  <span>Download Invoice</span>
                </Button>
                <Button className="flex items-center px-4 space-x-2 font-normal bg-[#f1f1f1]  border-none rounded-none h-5 hover:text-gray-600 focus:outline-none focus:ring-0">
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                  <span>Preview</span>
                </Button>
                <Button className="flex items-center px-4 space-x-2 font-normal bg-[#f1f1f1] border-gray-500 border-l rounded-l-none rounded-r-md h-5 hover:text-gray-600 focus:outline-none focus:ring-0">
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M18.364 5.636a9 9 0 11-12.728 0m12.728 0L12 12m0 0l-6.364-6.364" />
                  </svg>
                  <span>Report an issue</span>
                </Button>
              </div>
            }
          </div>
        </header>
        <div className="w-full mx-auto mt-10 p-6 border border-gray-300 shadow-lg rounded-lg">
          <Tab.Group>
            <Tab.List className="flex p-1 space-x-1 rounded-lg bg-[#e3e3e3] h-[38px] items-center">
              {tabs.map((tab, index) => (
                <Tab
                  key={tab}
                  className={({ selected }) =>
                    classNames(
                      "w-full rounded-md py-1.5 text-sm font-normal leading-5",
                      "focus:outline-none ",
                      selected ? "bg-white" : "hover:bg-white/[0.12] hover:text-black"
                    )
                  }
                  onClick={(e) => {
                    if ((invoiceDetails?.invoice?.invoice_number === "" ||
                      invoiceDetails?.invoice?.invoice_number === undefined ||
                      invoiceDetails?.invoice?.invoice_number === null) &&
                      index === 1) {
                      e.preventDefault();
                      toast({
                        description: "Invoice number is required",
                        variant: "destructive",
                      });
                      return;
                    }
                    //M10-11051
                    if ((invoiceDetails?.invoice?.textract && invoiceDetails?.invoice?.net_amount_validated == false) &&
                      index === 1) {
                      e.preventDefault();
                      toast({
                        description: "Please validate the Net Amount",
                        variant: "destructive",
                      });
                      return;
                    }
                    //M10-11051
                    // else if (invoiceDetails?.link_type == "DRDS" && !invoiceDetails?.counter_mci_number?.trim()) {
                    //   e.preventDefault();
                    //   toast({
                    //     description: "MCI not validated",
                    //     variant: "destructive",
                    //   });
                    //   return;
                    // }  //For now, allow to bypass even if mci number is not present in master
                    // else if (
                    //   (invoiceDetails?.link_type == "DRAPH" || invoiceDetails?.link_type == "INDPH-PH" || invoiceDetails?.link_type == "INDPH-HS") &&
                    //   (!invoiceDetails?.counter_dl_number?.trim() || invoiceDetails?.counter_dl_number?.trim() == undefined)
                    // ) {
                    //   e.preventDefault();
                    //   toast({
                    //     description: "DL not validated",
                    //     variant: "destructive",
                    //   });
                    //   return;
                    // }
                  }}
                >
                  {tab}
                </Tab>
              ))}
            </Tab.List>
            <Tab.Panels className="mt-2">
              <Tab.Panel className={classNames("rounded-xl w-full bg-white", "ring-white/60 ring-offset-2 focus:outline-none focus:ring-2")}>
                <InvoiceHeader />
              </Tab.Panel>
              <Tab.Panel className={classNames("rounded-xl bg-white", "ring-white/60 ring-offset-2 focus:outline-none focus:ring-2")}>
                <InvoiceProductMapping />
              </Tab.Panel>
            </Tab.Panels>
          </Tab.Group>
        </div>
      </div>
    </InvoiceLayout>
  );
};

export default InvoiceComparison;
